// Action Points — refill on day-start, spend on AP-costing actions.
// AP is per-day not per-week; opportunity-cost teaching is the whole point (ECONOMY §2).

import type { GameState } from '../state/types.js';

export function refillAP(state: GameState): GameState {
  return {
    ...state,
    ap: { ...state.ap, current: state.ap.perDay },
  };
}

export function canSpendAP(state: GameState, amount: number): boolean {
  return amount >= 0 && state.ap.current >= amount;
}

export function spendAP(state: GameState, amount: number): GameState {
  if (!canSpendAP(state, amount)) return state;
  return { ...state, ap: { ...state.ap, current: state.ap.current - amount } };
}
